export function signatureAppearanceRequest(
  apiBase: string,
  input: {
    name: string;
    type: 'personal_signature' | 'drawn_signature' | 'organization_seal';
    file: File;
  },
  isDemo: boolean,
  locale: 'de' | 'en'
): { url: string; init: RequestInit } {
  if (isDemo) {
    // The visitor's name and bytes never enter the Demo request.
    return {
      url: `${apiBase}/appearances/demo-sample`,
      init: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: input.type,
          mimeType: input.file.type,
          locale,
        }),
      },
    };
  }
  const formData = new FormData();
  formData.set('name', input.name);
  formData.set('type', input.type);
  formData.set('file', input.file);
  return {
    url: `${apiBase}/appearances`,
    init: { method: 'POST', body: formData },
  };
}
